import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { DolorReal } from '../components/DolorReal';
import { CausaReal } from '../components/CausaReal';
import { Timeline } from '../components/Timeline';
import { Ingredientes } from '../components/Ingredientes';
import { PruebaSocial } from '../components/PruebaSocial';
import { Resultados } from '../components/Resultados';
import { Testimonios } from '../components/Testimonios';
import { Diferenciacion } from '../components/Diferenciacion';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
import { StickyCTA } from '../components/StickyCTA';
export function Home() {
  return <main className="min-h-screen bg-white font-sans text-gray-900 selection:bg-esbelta-violet/20" data-id="element-319">
      <AnnouncementBar data-id="element-320" />
      <Header data-id="element-321" />
      <Hero data-id="element-322" />
      <DolorReal data-id="element-323" />
      <CausaReal data-id="element-324" />
      <Timeline data-id="element-325" />
      <Ingredientes data-id="element-326" />
      <PruebaSocial data-id="element-327" />
      <Resultados data-id="element-328" />
      <Testimonios data-id="element-329" />
      <Diferenciacion data-id="element-330" />
      <FAQ data-id="element-331" />
      <Footer data-id="element-332" />
      <StickyCTA data-id="element-333" />
    </main>;
}